// extracted by mini-css-extract-plugin
export default {"pop_up":"styles_pop_up__ekXWw","block":"styles_block__vOKBH"};